import { IConversionOffer, IOffer, IOfferData, IOfferRange, ISegmentOffer } from './type';

export const hydrateFormData = (data: ISegmentOffer) => {
	const hydratedData: IConversionOffer = { offer: [] };
	hydratedData.segmentName = data.segmentName;
	hydratedData.expName = data.expName;
	hydratedData.offerName = data.offerName;
	hydratedData.bucketName = data.bucketName;
	hydratedData.isActive = data.isActive;
	hydratedData.rank = data.rank;
	hydratedData.offer =
		data?.offer?.withdrawRange?.map((currentOffer: IOfferRange) => {
			const filteredOffer: any = {} as IOfferData;
			filteredOffer.startRange = currentOffer.range.start?.toLocaleString('en-IN');
			filteredOffer.endRange = currentOffer.range.end?.toLocaleString('en-IN');
			filteredOffer.totalPercentage = currentOffer?.rewardPercentage?.totalPercentage || 0;
			filteredOffer.cashbackPercentage = currentOffer?.rewardPercentage?.cashbackPercentage || 0;
			filteredOffer.bonusPercentage = currentOffer?.rewardPercentage?.bonusPercentage || 0;
			filteredOffer.totalFlatValue = currentOffer?.rewardFlatValue?.totalFlatValue?.toLocaleString('en-IN') || '0';
			filteredOffer.cashbackFlatValue = currentOffer?.rewardFlatValue?.cashbackFlatValue?.toLocaleString('en-IN') || '0';
			filteredOffer.bonusFlatValue = currentOffer?.rewardFlatValue?.bonusFlatValue?.toLocaleString('en-IN') || '0';
			return filteredOffer;
		}) || [];
	hydratedData.transactionAllowPerDay = data?.offer?.transactionAllowPerDay || 0;
	hydratedData.cashbackRewardLimit = data?.offer?.cashbackRewardLimit?.toLocaleString('en-IN') || '0';
	hydratedData.bonusRewardLimit = data?.offer?.bonusRewardLimit?.toLocaleString('en-IN') || '0';
	return hydratedData;
};

export const dehydrateFormData = (data: IConversionOffer): ISegmentOffer => {
	const conversionOffer: ISegmentOffer = { offer: {} as IOffer } as ISegmentOffer;
	conversionOffer.segmentName = data.segmentName;
	conversionOffer.offerName = data.offerName;
	conversionOffer.bucketName = data.bucketName;
	conversionOffer.expName = data.expName;
	conversionOffer.rank = data.rank;
	conversionOffer.offer.transactionAllowPerDay = data.transactionAllowPerDay;
	conversionOffer.offer.cashbackRewardLimit = Number(data.cashbackRewardLimit?.replace(/,/g, ''));
	conversionOffer.offer.bonusRewardLimit = Number(data.bonusRewardLimit?.replace(/,/g, ''));
	conversionOffer.offer.withdrawRange = data.offer.map((currentOffer: any) => {
		const filteredOffer: any = {};
		filteredOffer.range = { start: +currentOffer.startRange?.replace(/,/g, '') };
		if (+currentOffer.endRange?.replace(/,/g, '')) filteredOffer.range.end = +currentOffer.endRange?.replace(/,/g, '');
		if (currentOffer.cashbackPercentage > 0 || currentOffer.bonusPercentage > 0 || currentOffer.totalPercentage > 0) {
			filteredOffer.rewardPercentage = {
				totalPercentage: currentOffer.totalPercentage,
				cashbackPercentage: currentOffer.cashbackPercentage,
				bonusPercentage: currentOffer.bonusPercentage
			};
		}
		if (
			+currentOffer?.cashbackFlatValue?.replace(/,/g, '') > 0 ||
			+currentOffer?.bonusFlatValue?.replace(/,/g, '') > 0 ||
			+currentOffer?.totalFlatValue?.replace(/,/g, '') > 0
		) {
			filteredOffer.rewardFlatValue = {
				totalFlatValue: +currentOffer?.totalFlatValue?.replace(/,/g, ''),
				cashbackFlatValue: +currentOffer?.cashbackFlatValue?.replace(/,/g, ''),
				bonusFlatValue: +currentOffer?.bonusFlatValue?.replace(/,/g, '')
			};
		}
		return filteredOffer;
	});
	return conversionOffer;
};
